import { makeAutoObservable } from 'mobx';
import { Restaurant } from '../../models';
import moment from 'moment';
import { dateValidate, validateCurrentDate } from '../../constants/tool-order';
import { getPeriodFromDates, PeriodDateFilterValue } from '../../component/period-date-filter.component';

class DataAnalysisStore {
    // active tab
    activeTabIndex = 0;
    // 所属餐厅列表
    belongedRestaurant: Restaurant[] = [];
    // 当前选中的餐厅Index
    currentRestaurant: Restaurant = {};
    // 开始时间
    startDate: string = '';
    // 结束时间
    endDate: string = '';

    // 选择框的值
    pickerValue: [Date | null, Date | null] = [
        null,
        null
    ]

    constructor() {
        makeAutoObservable(this);
        // const startDate = new Date(new Date().setHours(4, 0, 0));
        // const endDate = new Date(new Date(new Date().setDate(new Date().getDate() + 1)).setHours(4, 0, 0));
        // this.startDate = moment(startDate).format('YYYY-MM-DD 04:00:00');
        // this.endDate = moment(endDate).format('YYYY-MM-DD 04:00:00');
        // this.pickerValue = [startDate, endDate]
        /**
         * @function this.validateCurrentDate() 校验商家当前进入系统的时间
         */
        const { startTime, endTime } = validateCurrentDate();

        this.startDate = startTime;
        this.endDate = endTime;
        this.pickerValue = [moment(startTime, 'YYYY-MM-DD HH:mm').toDate(), moment(endTime, 'YYYY-MM-DD HH:mm').toDate()]
    }

    /**
     * 获取数据
     * @param value
     */
    async fetchData(value: Restaurant[]) {
        this.setBelongedRestaurant(value || [])
        if ((value || []).length > 0) {
            this.setCurrentRestaurant(value?.[0])
        }
    }

    /**
     * 切换tab
     * @param value
     */
    setActiveTabIndex(value: number) {
        this.activeTabIndex = value
    }

    /**
     * 设置所属餐厅列表
     * @param value
     */
    setBelongedRestaurant(value: Restaurant[]) {
        this.belongedRestaurant = value
    }

    /**
     * 设置所属餐厅
     * @param value
     */
    setCurrentRestaurant(value: Restaurant) {
        this.currentRestaurant = value
    }

    /**
     * 开始时间
     * @param value
     */
    setStartDate(value: string) {
        this.startDate = value
    }

    /**
     * 结束时间
     * @param value
     */
    setEndDate(value: string) {
        this.endDate = value
    }

    /**
     * 更新时间范围（箭头函数保证作为回调时 this 指向 store，避免 Cannot set properties of undefined）
     */
    handleDateTime = (dates: [Date | null, Date | null]) => {
        if (!dates[0] || !dates[1]) {
            this.pickerValue = dates;
            return;
        }
        if (!dateValidate(dates[0], dates[1])) {
            return;
        }
        this.pickerValue = dates;
        this.setStartDate(moment(dates[0]).format('YYYY-MM-DD HH:mm:00'));
        this.setEndDate(moment(dates[1]).format('YYYY-MM-DD HH:mm:00'));
    };

    /**
     * 根据当前起止时间推断周期快捷选项（本月/本周/本日/自定义），供菜品分析等子页 AI 入参使用。
     * @returns 周期模式
     */
    getPeriodMode(): PeriodDateFilterValue {
        return getPeriodFromDates(this.startDate, this.endDate);
    }

}

const dataAnalysisStore = new DataAnalysisStore()

export default dataAnalysisStore;



